import { makeVar } from "@apollo/client";

// General Data

export const commonGeneralDataVar = makeVar({});

// CASCO

export const cascoQuotationsProcessingVar = makeVar(false);

export const cascoQuotationsStatusVar = makeVar();

export const cascoSelectionInProgressVar = makeVar(false);

export const cascoSelectedQuotationVar = makeVar({});

export const cascoOutdateSimulationVar = makeVar(false);

export const cascoPolicyDocumentNumberVar = makeVar();

// RCA

export const rcaQuotationsStatusVar = makeVar();

export const rcaSelectionInProgressVar = makeVar(false);

export const rcaSelectedQuotationVar = makeVar({});

export const rcaPolicyDocumentNumberVar = makeVar();
